var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"steps"}},[_c('h2',[_vm._v("Method")]),_c('ol',_vm._l((_vm.steps),function(step){return _c('li',{key:step.id},[_c('StepItem',{attrs:{"step":step,"ingredients":_vm.ingredients}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }